const keyMap = {
  lang: 'culture',
  skinid: 'skinname'
}

export default function remapParams(params) {
  const remappedParams = {}
  for (const prop of Object.keys(params)) {
    const loweredProp = String(prop).toLowerCase()
    if (keyMap[loweredProp]) {
      remappedParams[keyMap[loweredProp]] = params[prop]
    } else {
      remappedParams[loweredProp] = params[prop]
    }
  }
  return remappedParams
}
